export default __webpack_public_path__ + "static/media/logo.4400180a.png";